(() => {
  class UnlockingChatModalController {
    constructor($rootScope, $scope, $timeout, $interval, toastr, Orders, Messages, Users, Auth, $state, ngDialog) {
      'ngInject';

      Object.assign(this, {
        $scope,
        $rootScope,
        $timeout,
        $interval,
        toastr,
        Orders,
        Messages,
        Users,
        Auth,
        $state,
        ngDialog,
        staffDetails: $scope.ngDialogData.staffDetails,
        patientDetails: $scope.ngDialogData.patientDetails
      }); // Seconds since created

      var age = this.staffDetails.age; // Timeout

      var timeout = this.staffDetails.timeout; // Seconds to expire

      var expiration = timeout - age; // Seconds since created
      // var created = moment(this.staffDetails.created).unix();
      // Seconds now
      // var now = moment().unix();

      this.minutes = parseInt(age / 60);
      this.seconds = age - this.minutes * 60;
      this.expire_minutes = parseInt(expiration / 60);
      this.expire_seconds = expiration - this.expire_minutes * 60; // console.log("minutes:");
      // console.log(this.minutes);
      // console.log("seconds:");
      // console.log(this.seconds);
    }

    close() {
      this.$scope.closeThisDialog(false);
    }

    unlockChat() {
      this.$scope.closeThisDialog(true);
    }

  }

  UnlockingChatModalController.$inject = ["$rootScope", "$scope", "$timeout", "$interval", "toastr", "Orders", "Messages", "Users", "Auth", "$state", "ngDialog"];
  angular.module('pims').controller('UnlockingChatModalController', UnlockingChatModalController);
})();